import requstHelper from './requstHelper';
import store from '../store';

class userApi {
  // 默认构造函数
  constructor() {
    return this;
  }

  // 转换key值，部分接口不支持json
  static stringify = (param) => {
    const query = [];
    Object.keys(param).forEach((key) => {
      query.push(`${key}=${param[key]}`);
    });
    return query.join('&');
  };

  // 获取验证码
  static getVcode = (params) => {
    let myParams = userApi.stringify(params);
    return requstHelper.fetch('common/getVerificationCode', myParams,
    {
      header: {
        'content-type': 'application/x-www-form-urlencoded',
      },
      method: 'POST',
    });
  }
  // 用户登录
  static login = (params) => {
    const myParams = params;
    const moment = require('moment');
    myParams.companyCode = process.env.COMPANY_CODE;
    myParams.areaCode = process.env.AREA_CODE;
    myParams.platform = store.getters.platform; // 用户所在平台
    myParams.openId = moment().format('x')
    console.log('myParams',myParams)
    return requstHelper.fetch('accounts/login', myParams,
    {
      header: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });
  }
  //获取用户信息
  static getUserInfo = (params) => {
    const myParams = params || {};
    myParams.companyCode = process.env.COMPANY_CODE;
    myParams.areaCode = process.env.AREA_CODE;
    const userInfo = store.getters['user/userInfo'];
    const encrypt = store.getters['user/encrypt']; // 获取encrypt
    myParams.userId = userInfo.userId;
    return requstHelper.fetch('accounts/mobile/base/info', myParams,
    {
      header: {
        encrypt: encrypt,
      },
      method: 'POST',
    });
  }
  //获取医院列表
  static getHospitalList = (params) => {
    const myParams = params;
    return requstHelper.fetch('query/hospital/list', myParams);
  }
  // 获取城市基本信息
  static getCitys = () => {
    const myParams = {};
    myParams.companyCode = process.env.COMPANY_CODE;
    myParams.areaCode = process.env.AREA_CODE;
    return requstHelper.fetch('query/common/city/list', myParams);
  }
  //保存用户基本信息
  static saveUserBaseInfo = (params) => {
    const myParams = params;
    myParams.companyCode = process.env.COMPANY_CODE;
    myParams.areaCode = process.env.AREA_CODE;
    const userInfo = store.getters['user/userInfo'];
    const encrypt = store.getters['user/encrypt']; // 获取encrypt
    myParams.userId = userInfo.userId;
    return requstHelper.fetch('accounts/mobile/realname', myParams,
    {
      header: {
        encrypt: encrypt,
      },
      method: 'POST',
    });
  }
}

export default userApi;



// WEBPACK FOOTER //
// ./src/api/userAPI.js